import { h, type Component, type VNodeChild } from 'vue';
import type { GridFormatter } from '../types';

export function collectionSeparator(
  collection: GridFormatter['collection'],
): string {
  if (collection && typeof collection === 'object') {
    return (collection.separator ?? '').trim();
  }
  return '';
}

export function isCollectionFormatter(formatter: GridFormatter): boolean {
  return !!formatter.component && formatter.collection !== false;
}

export function collectionRenderer(formatter: GridFormatter): Component {
  const separator = collectionSeparator(formatter.collection);
  const component = formatter.component!;

  const renderer = (props: { value: any; context: any }): VNodeChild => {
    const items = Array.isArray(props.value) ? props.value : [props.value];
    const children: VNodeChild[] = [];

    items.forEach((item, index) => {
      if (index > 0 && separator) {
        children.push(separator);
      }
      children.push(
        h(
          component,
          {
            key: index,
            value: item,
            ...formatter.props?.(item, props.context),
          },
          () => [
            formatter.toText
              ? formatter.toText(item, props.context)
              : itemText(item),
          ],
        ),
      );
    });

    return h('span', { class: 'itp-data-grid__collection' }, children);
  };

  renderer.props = ['value', 'context'];
  return renderer as Component;
}

function itemText(item: any): string {
  return item == null ? '' : String(item);
}
